import { DefaultTheme } from 'styled-components';

import { AvailableThemes, ITheme } from './types';

/* - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - */

export const getTheme = (key: AvailableThemes, theme: DefaultTheme): ITheme => {
  const themes = {
    default: {
      background: theme.colors.primary.color,
      front: theme.colors.white,
    },
    'default-bordered': {
      background: 'transparent',
      front: theme.colors.primary.color,
      borderColor: theme.colors.primary.color,
    },
    blue01: {
      background: theme.colors.blue01.color,
      front: theme.colors.white,
    },
    blue02: {
      background: theme.colors.blue02.color,
      front: theme.colors.white,
    },
    blue03: {
      background: theme.colors.blue03.color,
      front: theme.colors.white,
    },
    'blue03-bordered': {
      background: theme.colors.white,
      front: theme.colors.blue03.color,
      borderColor: theme.colors.blue03.color,
    },
    gray_blue: {
      background: theme.colors.gray_blue.color,
      front: theme.colors.white,
    },
    'gray_blue02-bordered': {
      background: theme.colors.white,
      front: theme.colors.gray_blue02.color,
      borderColor: theme.colors.gray_blue02.color,
    },
    'gray_blue-bordered': {
      background: theme.colors.white,
      front: theme.colors.gray_blue.color,
      borderColor: theme.colors.gray_blue.color,
    },
    orange: {
      background: theme.colors.orange.color,
      front: theme.colors.white,
    },
    purple: {
      background: theme.colors.purple.color,
      front: theme.colors.white,
    },
    grey: {
      background: theme.colors.primary.color,
      front: theme.colors.white,
    },
    transparent: {
      background: 'transparent',
      front: theme.colors.primary.color,
      borderColor: theme.colors.primary.color,
    },
    light: {
      background: theme.colors.light.color,
      front: theme.colors.primary.color,
    },
    'light-bordered': {
      background: theme.colors.white,
      front: theme.colors.texts_light,
      borderColor: theme.colors.texts_light,
    },
    medium: {
      background: theme.colors.medium.color,
      front: theme.colors.medium.contrast,
    },
    dark: {
      background: theme.colors.dark.color,
      front: theme.colors.dark.contrast,
    },
    'dark-bordered': {
      background: theme.colors.dark.contrast,
      front: theme.colors.dark.color,
      borderColor: theme.colors.dark.color,
    },
    'dark-bordered-transparent': {
      background: 'transparent',
      front: theme.colors.dark.color,
      borderColor: theme.colors.dark.color,
    },
    confirmation: {
      background: theme.colors.confirmation.color,
      front: theme.colors.white,
    },
    'confirmation-bordered': {
      background: 'transparent',
      front: theme.colors.confirmation.color,
      borderColor: theme.colors.confirmation.color,
    },
    green: {
      background: theme.colors.confirmation.contrast,
      front: theme.colors.white,
    },
    danger: {
      background: theme.colors.danger.color,
      front: theme.colors.danger.contrast,
    },
    'danger-bordered': {
      background: theme.colors.danger.contrast,
      front: theme.colors.danger.color,
      borderColor: theme.colors.danger.color,
    },
    warning: {
      background: theme.colors.warning.color,
      front: theme.colors.warning.contrast,
    },
    information: {
      background: theme.colors.information.color,
      front: theme.colors.information.contrast,
    },
  };

  return themes[key];
};
